import { render, staticRenderFns } from "./VisioConfirm.vue?vue&type=template&id=5b2b6f6b&scoped=true"
import script from "./VisioConfirm.vue?vue&type=script&lang=js"
export * from "./VisioConfirm.vue?vue&type=script&lang=js"
import style0 from "./VisioConfirm.vue?vue&type=style&index=0&id=5b2b6f6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2b6f6b",
  null
  
)

export default component.exports